import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { LOCALES } from '../lib/locale';

export default function CountrySelector() {
  const { countryCode, changeCountry } = useLocale();
  
  return (
    <div className="country-selector" aria-label="Select country">
      <span>{LOCALES[countryCode]?.flag || '🌐'}</span>
      <select
        value={countryCode || 'IN'}
        onChange={(e) => changeCountry(e.target.value)}
      >
        {Object.entries(LOCALES).map(([code, l]) => (
          <option key={code} value={code}>{l.country_name}</option>
        ))}
      </select>
    </div>
  );
}
